import { filter, pathOr, pipe, props } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { useSportsbookSelector } from '../../store';

// todo refactor: we already have "categoriesBySportId" prop in store - need to make sure it's updated the same way the "categoriesIdsBySportId" does. And then - just take prop by path from store instead of filtering and mapping.
export const selectCategoriesBySportId = (sportId, serviceId) =>
  createSelector(
    pathOr([], ['categoriesIdsBySportId', sportId, serviceId]),
    pathOr({}, ['categories', serviceId, 'data']),
    pipe(props, filter(Boolean))
  );

export const useCategoriesBySportId = (sportId, serviceId) =>
  useSportsbookSelector(
    selectCategoriesBySportId,
    [sportId, serviceId],
    shallow
  );
